export default __webpack_public_path__ + "static/Furniture-Removal-895b953541921d273035cabbff6decfa.jpg";